<div class=" justify-center items-center hidden md:flex">
    <div class="w-[45px] h-[45px]" (click)="$event.stopPropagation()">
        <app-icon-button (click)="changeColor=!changeColor" >
    <svg *ngIf="!changeColor" width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>
    <svg *ngIf="changeColor" width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>
</app-icon-button>
</div>


<div *ngIf="changeColor" class="ml-[15px] w-full flex items-center justify-center z-[999999999999]" [@fadeInOut] (click)="$event.stopPropagation()">

    <div class=" flex items-center justify-center p-5  bg-gray-50 gap-5 rounded-xl shadow-2xl" >
       <div class="w-full flex flex-col justify-center items-center gap-3">
        <label> <h2 class="text-[var(--primary)] leading-6 text-[16px] font-medium font-heebo">Primary</h2></label>
       <input type="color" (input)="onColorChangePrimary($event)" [value]="primaryDemo">
       <h2 class="text-[var(--primary)] leading-6 text-[16px] font-medium font-heebo">{{primaryDemo}}</h2>
 </div>
 <div class="w-full flex flex-col justify-center items-center gap-3">
    <label> <h2 class="text-[var(--secondary)] leading-6 text-[16px] font-medium font-heebo">Secondary</h2></label>
   <input type="color" (input)="onColorChangeSecondary($event)" [value]="secondaryDemo" >
   <h2 class="text-[var(--secondary)] leading-6 text-[16px] font-medium font-heebo">{{secondaryDemo}}</h2>
</div>
<div class="w-full flex flex-col justify-center items-center gap-3">
    <label><h2 class="text-[var(--tertiary)] leading-6 text-[16px] font-medium font-heebo">Tertiary</h2></label>
   <input type="color" (input)="onColorChangeTertiary($event)" [value]="tertiaryDemo">
   <h2 class="text-[var(--tertiary)] leading-6 text-[16px] font-medium font-heebo">{{tertiaryDemo}}</h2>
</div>
<div class="w-full flex flex-col justify-center items-center gap-3">
    <label><h2 class="text-[var(--quaternary)] leading-6 text-[16px] font-medium font-heebo">Quaternary</h2></label>
   <input type="color" (input)="onColorChangeQuaternary($event)" [value]="quaternaryDemo">
   <h2 class="text-[var(--quaternary)] leading-6 text-[16px] font-medium font-heebo">{{quaternaryDemo}}</h2>
</div>
 

 </div>
 </div>
</div>

<!-- 
mobile modal -->


<div class="size-full justify-center items-center flex flex-col  md:hidden mb-[15px]">
<div class="size-full relative">
    <div class="w-[45px] h-[45px]" (click)="$event.stopPropagation()" >
        <app-icon-button (click)="changeColor=!changeColor"  >
    
    <svg *ngIf="!changeColor" width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg>
    <svg *ngIf="changeColor" width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"/></svg>
   
</app-icon-button>
</div>


<div *ngIf="changeColor" class=" w-full flex flex-col items-center justify-center z-[999999999999] mt-[15px] absolute top-10 left-0" [@slideDownUp] (click)="$event.stopPropagation()">
    <div class=" flex flex-col items-center justify-center p-5  bg-gray-50 gap-5 rounded-xl shadow-2xl" >
       <div class="w-full flex flex-col justify-center items-center gap-3 mod">
        <label> <h2 class="text-[var(--primary)] leading-6 text-[16px] font-medium font-heebo">Primary</h2></label>
       <input type="color" (input)="onColorChangePrimary($event)" [value]="primaryDemo">
       <h2 class="text-[var(--primary)] leading-6 text-[16px] font-medium font-heebo">{{primaryDemo}}</h2>
 </div>
 <div class="w-full flex flex-col justify-center items-center gap-3">
    <label> <h2 class="text-[var(--secondary)] leading-6 text-[16px] font-medium font-heebo">Secondary</h2></label>
   <input type="color" (input)="onColorChangeSecondary($event)" [value]="secondaryDemo" >
   <h2 class="text-[var(--secondary)] leading-6 text-[16px] font-medium font-heebo">{{secondaryDemo}}</h2>
</div>
<div class="w-full flex flex-col justify-center items-center gap-3">
    <label><h2 class="text-[var(--tertiary)] leading-6 text-[16px] font-medium font-heebo">Tertiary</h2></label>
   <input type="color" (input)="onColorChangeTertiary($event)" [value]="tertiaryDemo">
   <h2 class="text-[var(--tertiary)] leading-6 text-[16px] font-medium font-heebo">{{tertiaryDemo}}</h2>
</div>
<div class="w-full flex flex-col justify-center items-center gap-3">
    <label><h2 class="text-[var(--quaternary)] leading-6 text-[16px] font-medium font-heebo">Quaternary</h2></label>
   <input type="color" (input)="onColorChangeQuaternary($event)" [value]="quaternaryDemo">
   <h2 class="text-[var(--quaternary)] leading-6 text-[16px] font-medium font-heebo">{{quaternaryDemo}}</h2>
</div>
 </div>
 </div>
</div>
</div>